import Lobby from '@/modules/lobby/containers/Lobby.vue';

export default [
    {
        path: '/lobby',
        name: 'Lobby',
        component: Lobby,
        meta: { requiresNavbar: true },
    }
]
